import * as z from "zod";

export const applyOptimizationJobDrafts = {
  name: "applyOptimizationJobDrafts" as const,
  input: z.object({
    jobId: z.bigint(),
    fields: z.array(z.string()).optional(),
  }),
  output: z.void(),
};
